import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toSeconds } from "@/lib/intervals";

export default function MinSecInput({ label, min, sec, onChange, testId, hint }) {
  const total = toSeconds(min, sec);
  return (
    <div>
      {label && <Label className="hs-label">{label}</Label>}
      <div className="mt-2 grid grid-cols-2 gap-3">
        <Input type="number" min="0" step="1" value={min ?? ""} onChange={(e) => onChange(e.target.value, sec)}
               className="h-11 rounded-xl font-data" placeholder="min" data-testid={`${testId}-min`} />
        <Input type="number" min="0" max="59" step="1" value={sec ?? ""} onChange={(e) => onChange(min, e.target.value)}
               className="h-11 rounded-xl font-data" placeholder="sec" data-testid={`${testId}-sec`} />
      </div>
      <p className="text-[10px] text-ink-3 mt-1 font-data">= {total || "—"}s{hint ? ` · ${hint}` : ""}</p>
    </div>
  );
}
